<template>
    <div class="space-y-4">
        <h5>
            <span class="h-3 w-1" />
            {{ trans('maintainers.sla.resolution_priorities.title') }}
        </h5>

        <table class="w-full table-fixed text-sm">
            <thead>
                <tr>
                    <th class="w-1/4 pb-2 text-left font-medium">
                        {{ trans('maintainers.sla.priority.title') }}
                    </th>
                    <th class="pb-2 text-left font-medium">
                        <div class="flex items-center justify-start gap-2">
                            <span>{{ trans('maintainers.sla.time_to_respond.title') }}</span>
                            <info-icon :tooltip="trans('maintainers.sla.time_to_respond.tooltip')" />
                        </div>
                    </th>
                    <th class="pb-2 text-left font-medium">
                        <div class="flex items-center justify-start gap-2">
                            <span>{{ trans('maintainers.sla.time_to_resolve.title') }}</span>
                            <info-icon :tooltip="trans('maintainers.sla.time_to_resolve.tooltip')" />
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="priority in priorities" :key="priority">
                    <td class="py-1 align-middle">
                        <work-order-priority :priority="getPriorityLabel(priority)" />
                    </td>
                    <td class="py-1">
                        <duration-selector
                            :duration-units="durationUnits"
                            :model-value="modelValue?.timeToRespond?.[priority]"
                            @update:model-value="update('timeToRespond', priority, $event)"
                        />
                    </td>
                    <td class="py-1">
                        <duration-selector
                            :duration-units="durationUnits"
                            :model-value="modelValue?.timeToResolve?.[priority]"
                            @update:model-value="update('timeToResolve', priority, $event)"
                        />
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script setup>
import { usePage } from '@inertiajs/vue3';
import { trans } from '@/mixins/i18n';
import DurationSelector from '@/Pages/Stakeholders/Maintainers/DurationSelector.vue';
import WorkOrderPriority from '@/Pages/WorkOrders/Modals/WorkOrderPriority.vue';
import InfoIcon from '@/Components/InfoIcon.vue';

const props = defineProps({
    modelValue: {
        type: Object,
        required: true,
    },
    durationUnits: {
        type: Array,
        default: () => [],
    },
});

const emit = defineEmits(['update:modelValue']);

const page = usePage();
const priorities = ['high', 'medium', 'low'];

const getPriorityLabel = (priority) =>
    page.props.priorities?.data?.find((el) => el.value === priority) || {
        value: priority,
        label: priority,
    };

const update = (section, priority, value) => {
    const current = props.modelValue ?? {};
    emit('update:modelValue', {
        ...current,
        [section]: {
            ...(current[section] ?? {}),
            [priority]: value,
        },
    });
};
</script>
